class AccordianDrawer extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = this.querySelectorAll('.accordion-drawer');
    this.closeButtons = this.querySelectorAll('.accordion-drawer-close');
    this.animations = new Map();
    this.isClosing = new Map();
    this.isExpanding = new Map();
    this.initEvents();
  }

  initEvents() {
    this.closeButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.closeDrawer(this.detailsElements[index], index);
      });
    });
    window.addEventListener('scroll', () => {
      if (this.querySelector('.accordion-drawer[open]')) return;
      this.detailsElements.forEach((detailsElement) => {
        const contentWrapper = detailsElement.querySelector(
          '.accordion-drawer__content .accoridion-content-wraper'
        );
        if (contentWrapper) {
          if (window.scrollY > 32) {
            contentWrapper.style.transform = `translateY(${window.scrollY + 7}px)`;
          } else {
            contentWrapper.style.transform = 'translateY(40px)';
          }
        }
      });
    });
    this.detailsElements.forEach((detailsElement, index) => {
      let contentWrapper = detailsElement.querySelector('.accordion-drawer__content .accoridion-content-wraper');
      contentWrapper.style.transform = `translateY(40px)`;
      const summary = detailsElement.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleDrawer(detailsElement, index);
            const dataIndex = detailsElement.getAttribute('data-index');
            const insideDetails = document.querySelectorAll('.accordion-wrapper acordion-animated');
            insideDetails.forEach((detail) => {
              if(detail.querySelector('details').getAttribute('data-index') == dataIndex){
                if( !detail.querySelector('details').hasAttribute('open')){
                  detail.querySelector('details').setAttribute("open",'open');
                }
              }
              else{
                detail.querySelector('details').removeAttribute("open");
              }
            });
        });
      }
      
      detailsElement.addEventListener('toggle', () => {
        this.syncPageScrollLock();
      });
    });
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  // Use the same body.top formula as applyKiwiBodyScrollGuard in product-parallax-mobile.js
  // so that when Kiwi size chart opens from the accordion, both locks agree on top value.
  _getScrollLockTop(scrollY) {
    const isMobile = window.innerWidth <= 1023;
    if (isMobile) {
      const sh = document.querySelector('sticky-header');
      let headerHeight = sh ? sh.offsetHeight - 2 : 0;
      if (!headerHeight) {
        const hEl = document.querySelector('.shopify-section-header-wrapper, .section-header, header');
        headerHeight = hEl ? hEl.offsetHeight - 2 : 0;
      }
      return '-' + Math.round(Math.max(scrollY - headerHeight, 0)) + 'px';
    }
    return '-' + Math.round(scrollY) + 'px';
  }

  syncPageScrollLock() {
    const anyOpen = this.querySelector('.accordion-drawer[open]');
    if (anyOpen) {
      if (this._scrollLockY != null) return;
      // If Kiwi size chart is open, read scroll Y from its saved state
      // so we don't overwrite body.style.top with a stale/wrong value.
      if (window.__pdpKiwiModalOpen) {
        this._scrollLockY = window.scrollY;
        return;
      }
      this._scrollLockY = window.scrollY;
      document.documentElement.classList.add('accordion-drawer-scroll-lock');
      document.body.classList.add('accordion-drawer-scroll-lock');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.setProperty('position', 'fixed', 'important');
      document.body.style.setProperty('top', this._getScrollLockTop(this._scrollLockY), 'important');
      document.body.style.setProperty('left', '0', 'important');
      document.body.style.setProperty('right', '0', 'important');
      document.body.style.setProperty('width', '100%', 'important');
      document.body.style.setProperty('overflow', 'hidden', 'important');
      return;
    }
    if (this._scrollLockY == null) return;
    // If Kiwi is still open, don't release the scroll lock yet —
    // let Kiwi's own close handler restore the scroll position.
    if (window.__pdpKiwiModalOpen) return;
    const y = this._scrollLockY;
    this._scrollLockY = null;
    document.documentElement.classList.remove('accordion-drawer-scroll-lock');
    document.body.classList.remove('accordion-drawer-scroll-lock');
    document.documentElement.style.overflow = '';
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
    document.body.style.removeProperty('right');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow');
    requestAnimationFrame(() => window.scrollTo(0, y));
  }

  getContentElement(detailsElement) {
    let content = detailsElement.querySelector('.accordion-drawer-content');
    if (!content) {
      const summary = detailsElement.querySelector('summary');
      if (summary && summary.nextElementSibling) {
        content = summary.nextElementSibling;
      }
    }
    return content;
  }

  toggleDrawer(detailsElement, index) {
    const content = this.getContentElement(detailsElement);
    if (!content) {
      console.error('Content element not found for drawer', index);
      return;
    }
    if (this.animations.has(index)) {
      this.animations.get(index).cancel();
    }
    if (this.isClosing.get(index) || !detailsElement.hasAttribute('open')) {
      this.closeOtherDrawers(index);
      this.openDrawer(detailsElement, index);
    } else if (this.isExpanding.get(index) || detailsElement.hasAttribute('open')) {
      this.closeDrawer(detailsElement, index);
    }
  }

  closeOtherDrawers(exceptIndex) {
    this.detailsElements.forEach((details, idx) => {
      if (idx !== exceptIndex && details.hasAttribute('open')) {
        this.closeDrawer(details, idx);
      }
    });
  }

  openDrawer(detailsElement, index) {
    const content = this.getContentElement(detailsElement); 
    if (!content) return; 
    detailsElement.setAttribute('open', ''); 
    this.isExpanding.set(index, true);
    this.isClosing.set(index, false); 
    const startHeight = content.offsetHeight; 
    content.style.overflow = 'hidden';
    const animation = content.animate([
      { transform: 'translateX(100%)' },
      { transform: 'translateX(0)' }
    ], {
      duration: 100,
      easing: 'ease-out'
    });
    
    this.animations.set(index, animation); 
    animation.onfinish = () => {
      content.style.transform = '';
      content.style.overflow = '';  
      this.isExpanding.set(index, false);
      this.animations.delete(index);
      this.syncPageScrollLock();
    };
    animation.oncancel = () => {
      this.isExpanding.set(index, false);
    };
  }

  closeDrawer(detailsElement, index) {
    const content = this.getContentElement(detailsElement);  
    if (!content) return;
    this.isClosing.set(index, true);
    this.isExpanding.set(index, false);
    content.style.overflow = 'hidden';
    const animation = content.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(100%)' }
    ], {
      duration: 100,
      easing: 'ease-in'
    });
    
    this.animations.set(index, animation); 
    animation.onfinish = () => {
      detailsElement.removeAttribute('open');
      content.style.overflow = '';    
      this.isClosing.set(index, false);
      this.animations.delete(index);    
      this.syncPageScrollLock();
    };

    animation.oncancel = () => {
      this.isClosing.set(index, false);
    };
  }

  handleOutsideClick(event) {
    this.detailsElements.forEach((detailsElement, index) => {
      if (!this.contains(event.target) && detailsElement.hasAttribute('open')) {
        this.closeDrawer(detailsElement, index);
      }
    });
  }
  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this)); 
    this.animations.forEach(animation => {
      if (animation) animation.cancel();
    });
  }
}

customElements.define('accordian-drawer', AccordianDrawer);